module.exports = __webpack_public_path__ + "img/07.030a13a6.jpg";